// The chat's icons: 12 px, one 1.5 px stroke, in the text colour around them (a status colour comes from the
// class on the wrapper, never from the icon). Replaces the text marks (✓ ✗ ↺ ·), which line up differently per font.
import type { SVGProps } from "react";

const base = (p: SVGProps<SVGSVGElement>): SVGProps<SVGSVGElement> => ({
  width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", stroke: "currentColor", strokeWidth: 1.5,
  strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": true, ...p,
});

export const IconDone = (p: SVGProps<SVGSVGElement>) => <svg {...base(p)}><path d="M2.5 6.3 5 8.7l4.5-5.2" /></svg>;
export const IconFailed = (p: SVGProps<SVGSVGElement>) => <svg {...base(p)}><path d="M3.2 3.2l5.6 5.6M8.8 3.2 3.2 8.8" /></svg>;
export const IconRetried = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}><path d="M2.6 5.2A3.6 3.6 0 1 1 3.4 8.6" /><path d="M2.4 2.6v2.8h2.8" /></svg>
);
export const IconWarning = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)}><path d="M6 1.8 10.6 10H1.4z" /><path d="M6 5v2.2" /><path d="M6 8.7h0" strokeWidth={1.8} /></svg>
);
export const IconChevron = ({ open, ...p }: SVGProps<SVGSVGElement> & { open: boolean }) => (
  <svg {...base(p)} className={`chev ${open ? "open" : ""}`}><path d="M4.5 3 7.5 6l-3 3" /></svg>
);
// running: a ring with a quarter arc; turns (CSS), unless the person asked for reduced motion
export const IconRunning = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)} className="icon-run"><circle cx="6" cy="6" r="4.2" opacity={0.25} /><path d="M6 1.8a4.2 4.2 0 0 1 4.2 4.2" /></svg>
);
// thinking: three dots that take turns (CSS), still under reduced motion
export const IconThinking = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base(p)} className="icon-think"><circle cx="2.6" cy="6" r=".9" /><circle cx="6" cy="6" r=".9" /><circle cx="9.4" cy="6" r=".9" /></svg>
);
